import React from 'react';
import CreateTemplate from '../Templates/CreateTemplate';

const CreateFile = () => (
  <CreateTemplate
    typeSelector={true}
    callback={(history) => history.push('/documents')}
  />
);

export default CreateFile;
